import { render, staticRenderFns } from "./CommodityList.vue?vue&type=template&id=c3c9a0e6"
import script from "./CommodityList.vue?vue&type=script&lang=js"
export * from "./CommodityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports